<template>
  <QS-common-table
    :columns="columns"
    :data="tableData"
    :pagination="pagination"
    row-key="receivableId"
    @change="handleChange"
  >
  </QS-common-table>
</template>

<script>
import { mapState } from 'vuex'
import selectOption from '@/store/dict/selectOptionDict'
import {
  getBatchReceivableOrderPageList,
  getBatchPaymentOrderPageList,
} from '@/api/financeApi'

export default {
  name: 'CollectionRecordDetailsTable',
  data() {
    return {
      tableData: [],
      receivableColumns: [
        {
          name: 'receiptId',
          columnProps: {
            label: '收款单ID',
            prop: 'receiptId',
            width: 100,
          },
        },
        {
          name: 'receivableId',
          columnProps: {
            label: '应收ID',
            prop: 'receivableId',
            width: 100,
          },
        },
        {
          name: 'customerType',
          columnProps: {
            label: '付款方类型',
            prop: 'customerType',
            width: 100,
          },
          render: ({ row }) => (
            <span>{row.customerType === 1 ? '服务商' : '客户'}</span>
          ),
        },
        {
          name: 'customerId',
          columnProps: {
            label: '付款方id',
            prop: 'customerId',
            width: 100,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            label: '付款方名称',
            prop: 'customerName',
            width: 100,
          },
        },
        {
          name: 'customerInfoType',
          columnProps: {
            label: '客户类型',
            prop: 'customerInfoType',
            width: 100,
          },
          render: ({ row }) => {
            if (!row.customerInfoType) return <span>--</span>
            return <span>{row.customerInfoType === 1 ? '个人' : '企业'}</span>
          },
        },
        {
          name: 'content',
          columnProps: {
            label: '收款内容',
            prop: 'content',
          },
          getText: ({ row }) => this.freeTypeListCmp[row.content],
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
        },
        {
          name: 'sourceOrderType',
          columnProps: {
            label: '来源单类型',
            prop: 'sourceOrderType',
            minWidth: '130',
          },
          render: ({ row }) => (
            <span>{selectOption.sourceOrderTypeDict[row.sourceOrderType]}</span>
          ),
        },
        {
          name: 'sourceOrderId',
          columnProps: {
            label: '来源单ID',
            prop: 'sourceOrderId',
          },
        },
        {
          name: 'receivableDate',
          columnProps: {
            label: '应收日期',
            prop: 'receivableDate',
            width: 100,
          },
        },
        {
          name: 'stateDesc',
          columnProps: {
            label: '收款单状态',
            prop: 'stateDesc',
            minWidth: '100',
          },
        },
        {
          name: 'amount',
          columnProps: {
            label: '本次收款金额（元）',
            prop: 'amount',
            minWidth: '150',
          },
        },
      ],
      paymentColumns: [
        {
          name: 'index',
          columnProps: {
            label: '序号',
            prop: 'index',
          },
        },
        {
          name: 'paymentId',
          columnProps: {
            label: '应付ID',
            prop: 'paymentId',
          },
        },
        {
          name: 'payType',
          columnProps: {
            label: '付款内容',
            prop: 'payType',
          },
          getText: ({ row }) =>
            this.formatEnumeration(this.freeTypeList)[row.payType],
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
        },
        {
          name: 'sourceOrderType',
          columnProps: {
            label: '来源单类型',
            prop: 'sourceOrderType',
          },
          getText: ({ row }) =>
            selectOption.sourceOrderTypeDict[row.sourceOrderType],
        },
        {
          name: 'sourceOrderId',
          columnProps: {
            label: '来源单ID',
            prop: 'sourceOrderId',
          },
        },
        {
          name: 'payDate',
          columnProps: {
            label: '应付日期',
            prop: 'payDate',
          },
        },
        {
          name: 'amount',
          columnProps: {
            label: '本次支付金额（元）',
            prop: 'amount',
            width: '160',
          },
          getText: ({ row }) => this.numberWithCommas(row.amount),
        },
        {
          name: 'paymentOrderId',
          columnProps: {
            label: '付款单ID',
            prop: 'paymentOrderId',
          },
        },
      ],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [10, 20, 50, 100],
      },
    }
  },

  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    scenetype: {
      type: String,
      default: '',
    },
  },
  watch: {
    id(n, o) {
      if (n !== o) {
        this.getBatchReceivableOrderPageList()
      }
    },
  },
  mounted() {
    this.getBatchReceivableOrderPageList()
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    columns() {
      if (this.scenetype === 'receivable') {
        return [...this.receivableColumns]
      }
      if (this.scenetype === 'payment') {
        return [...this.paymentColumns]
      }
      return []
    },
    pageAction() {
      if (this.scenetype === 'receivable') {
        return getBatchReceivableOrderPageList
      }
      if (this.scenetype === 'payment') {
        return getBatchPaymentOrderPageList
      }
      return null
    },
    freeTypeListCmp() {
      return this.formatEnumeration(this.freeTypeList)
    },
  },
  methods: {
    handleChange({ pagination }) {
      this.pagination = { ...pagination }
      this.getBatchReceivableOrderPageList()
    },
    // 获取应收列表数据
    getBatchReceivableOrderPageList() {
      if (!this.id) return
      if (!this.pageAction) return
      this.pageAction({
        id: Number(this.id),
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        const { code, data } = res
        this.tableData = []
        if (code === 1 && data.items && Array.isArray(data.items)) {
          this.pagination.total = data.totalNum
          this.tableData = data.items.map((item, index) => ({
            ...item,
            index: index + 1,
            stateDesc: selectOption.collectionStateList[item.state] || '--',
          }))
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.add-table ::v-deep .el-form-item {
  margin-top: 20px;
  margin-bottom: 20px;
}
.add-table ::v-deep td {
  padding: 0 !important;
}
.add-table {
  ::v-deep thead tr {
    background-color: #f7f8fa;
  }
}
#app .add-table ::v-deep thead tr th {
  border: none !important;
}
.delete-order {
  &-btns {
    text-align: right;
    margin: 0;
    display: flex;
    justify-content: flex-end;
    margin-top: 20px !important;
    .cancel-btn {
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      border: 1px solid #dcdee0;
      font-family: PingFangSC-Regular;
      color: #323233;
      border-radius: 3px;
      font-size: 12px;
    }
  }
}
</style>
